import getApi from '../tools/api/progress';
import { get } from '../tools/http';

const api = getApi({ isMock: false });

export default {
    namespaced: true,
    state: {
        competences: [],
        groupedCompetences: {},
    },
    mutations: {
        setCompetences: (state, competences) => state.competences = competences,
        setGroupedCompetences: (state, competences) => state.groupedCompetences = competences,
        replaceCompetence: (state, item) => {
            let items = state.competences.slice();
            let index = items.findIndex(v => v.id === item.id);
            if (index > -1) {
                items.splice(index, 1, item);
            }
            state.competences = items;
        },
    },
    actions: {
        loadCompetences: async (ctx) => {
            const res = await api.loadUserCompetences();
            if (res && res.items) {
                ctx.commit('setCompetences', res.items);
            }
        },
        async setCompetenceAcknowledge(ctx, { competenceId, status }) {
            let res = await api.updateCompetence(competenceId, { userAcknowledgment: status });
            res && ctx.commit('replaceCompetence', res);
        },
        async addCompetenceToTrack(ctx, { competenceId, trackId }) {
            let res = await api.addTrackCompetence(competenceId, { trackId });
            if (res) {
                let item = ctx.state.competences.find(v => v.id === competenceId);
                if (item) {
                    item.isInTrack = true;
                    res && ctx.commit('replaceCompetence', item);
                }
            }
        },
        async loadGroupedCompetences(ctx) {
            const res = await get('competence-sync', 'api/v1/userCompetence', null, true);
            const groups = {};

            if (res && res.data) {
                for (const item of res.data) {
                    const name = item.group_name;

                    if (groups[name] === undefined) {
                        groups[name] = [];
                    }

                    groups[name].push(item);
                }
            }

            ctx.commit('setGroupedCompetences', groups);
        },
    },
    getters: {
        getCompetences: (state) => state.competences,
        getGroupedCompetences: (state) => state.groupedCompetences,
    },
};
